import { render, staticRenderFns } from "./DissolutionNGOModal.vue?vue&type=template&id=fba7d512&"
import script from "./DissolutionNGOModal.vue?vue&type=script&lang=js&"
export * from "./DissolutionNGOModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports